module.exports = __webpack_public_path__ + "img/sound-stimuli-symbol.bfda42f6.svg";